module.exports = __webpack_public_path__ + "static/media/knightWhiteNew.72058977.svg";